<template>
    <OverlayPanel ref="op" :showCloseIcon="true" id="overlay_panel" style="width: 450px" :breakpoints="{ '960px': '75vw' }">
        <i>To attach attributes, just copy and paste your desired attribute's "VALUE" section</i>
        <DataTable :value="blockAttributes" :paginator="true" :rows="5" responsiveLayout="scroll">
            <Column field="label" header="LABEL"></Column>
            <Column field="variable" header="VARIABLE"> </Column>
            <template #empty> No Attributes found </template>
        </DataTable>
    </OverlayPanel>
</template>

<script>
import { ref, onMounted, watch } from 'vue';
import useBlockComposable from '@/composables/BlockComposable';

export default {
    props: {
        selectedBlockId: String,
        toggle: Object,
    },
    setup(props, { emit }) {
        const { block, getBlockDetails } = useBlockComposable();
        const op = ref();
        const blockAttributes = ref([]);
        watch(
            () => props.toggle,
            (newValue) => {
                op.value?.toggle(newValue);
            }
        );

        onMounted(async () => {
            await getBlockDetails('Company', props.selectedBlockId);
            await setBlockAttributes();
        });

        const setBlockAttributes = async () => {
            blockAttributes.value = block.value?.attributes?.map((attribute) => {
                return {
                    // id: element.attribute?.id,
                    label: attribute?.label,
                    code: attribute?.code,
                    variable: '{{' + attribute?.code + '}}',
                };
            });
            emit('blockAttributesSet', blockAttributes.value);
        };
        return {
            op,
            blockAttributes,
        };
    },
};
</script>
